module.exports = __webpack_public_path__ + "static/media/Leaddev.6e3a6fff.png";